import useApi from '../../api/backendApiContext';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import { useQuery } from '@tanstack/react-query';
import { ReactQueryConstants } from '../../commons/constants';

export const useFetchedEnterpriseChartsAmount = () => {
  const { analyticsApi } = useApi();
  return useQuery(
    useQueryCacheManager().getEnterpriseChartsAmountCacheKey(),
    async () => analyticsApi.getEnterpriseChartsAmount(),
    {
      staleTime: ReactQueryConstants.enterpriseChartsAmountStaleTime,
      refetchOnWindowFocus: false,
    }
  );
};
